var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { Close } from '@mui/icons-material';
import { ButtonBase, Dialog, DialogContent, DialogTitle, IconButton, Link, Typography, Box, } from '@mui/material';
import { BackrsForm } from './BackrsForm';
import { handlePhoneLogin } from '../Login/login.util';
var LOGIN_STRINGS = appStrings.modules.login;
var defaultForgotPasswordValues = {
    forgotPasswordEmail: '',
};
export var ResendCode = function (_a) {
    var environmentUrl = _a.environmentUrl;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var openModal = function () { return setIsOpen(true); };
    var closeModal = function () { return setIsOpen(false); };
    var fields = [
        {
            id: 'phone',
            name: 'phone',
            placeholder: LOGIN_STRINGS.phonePlaceholder,
            type: 'tel',
            autoComplete: 'phone',
            icon: {
                type: 'LEFT_ICON',
                leftIcon: 'Phone',
            },
            inputProps: { maxLength: 10 },
            rules: {
                pattern: { value: /^\d{10}$/, message: LOGIN_STRINGS.error.invalidPhone },
            },
        },
    ];
    var handleSubmission = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    return [4, handlePhoneLogin(data.phone, environmentUrl)];
                case 1:
                    _b.sent();
                    return [3, 4];
                case 2:
                    _a = _b.sent();
                    console.log('Error resending verification code');
                    return [3, 4];
                case 3:
                    closeModal();
                    return [7];
                case 4: return [2];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(ButtonBase, { id: "resend-code-button", sx: noCodeStyle, disableRipple: true, children: _jsxs(Typography, { variant: "text-sm-regular", color: function (theme) { return theme.backrs.colors['Colors/Text/text-tertiary']; }, children: [LOGIN_STRINGS.otp.didntReceiveText, ' ', _jsx(Box, { component: "span", onClick: openModal, sx: clickToResendSx, children: LOGIN_STRINGS.otp.clickToResend })] }) }), _jsxs(Dialog, { PaperProps: {
                    style: { borderRadius: 8 },
                }, open: isOpen, onClose: closeModal, children: [_jsx(DialogTitle, { mt: 2, children: _jsx(IconButton, { id: "resend-code-close-button", "aria-label": "close", onClick: closeModal, sx: dialogCloseButtonStyle, children: _jsx(Close, {}) }) }), _jsxs(DialogContent, { children: [_jsx(Typography, { children: LOGIN_STRINGS.otp.resendCode }), _jsx(BackrsForm, { fields: fields, defaultValues: defaultForgotPasswordValues, buttonLabel: "Send", onSubmit: handleSubmission, children: _jsxs(Typography, { sx: contactSupportTextStyle, children: [LOGIN_STRINGS.otp.contactSupportPrompt, _jsx(Link, { id: "resend-code-contact-support-link", href: "mailto:support@backrs.com?subject=Backrs App - Contact Request", sx: contactSupportLinkStyle, children: LOGIN_STRINGS.otp.contactSupportButton })] }) })] })] })] }));
};
var clickToResendSx = function (_a) {
    var backrs = _a.backrs, typography = _a.typography;
    return (__assign({ color: backrs.colors['Brand/700'], cursor: 'pointer' }, typography['text-sm-semibold']));
};
var noCodeStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        my: backrs.spacing['spacing-4xl'],
    });
};
var contactSupportTextStyle = {
    fontSize: '0.8125rem',
    textAlign: 'center',
    mt: 1,
};
var contactSupportLinkStyle = {
    color: appColors.color.navy2,
    fontWeight: 700,
    textDecoration: 'none',
    cursor: 'pointer',
};
var dialogCloseButtonStyle = {
    position: 'absolute',
    right: 8,
    top: 8,
};
